import styles from './index.module.sass';
import indexSvg from './index.svg';

export const MixStepsBadge = ({ stepsCount, onClick }: IMixStepsBadge) => {
    return (
        <div className={styles.mixStepsBadge}>
            <span>шагов миксования в этой паре</span>
            <div className={styles.iteration}>
                <span className={styles.iterationsCount}>{ stepsCount }</span>
                <img src={indexSvg} alt="iteration"/>
            </div>
            <a className={styles.more} onClick={(e) => {
                e.preventDefault();
                onClick();
            }}>подробнее</a>
        </div>
    )
}

interface IMixStepsBadge {
    stepsCount: number
    onClick: () => void;
}